/* ARTMiE Load More Button
   Replaces automatic infinite scroll with a visible "Load more" button.
   Works with Horizon's PaginatedList/ResultsList components. */

(function () {
  'use strict';

  /* Guard: prevent double init when script is loaded from multiple places */
  if (window._artmieLoadMoreDone) return;
  window._artmieLoadMoreDone = true;

  /* ── Inject styles ── */
  var style = document.createElement('style');
  style.textContent = [
    '.artmie-load-more-wrap{display:flex;align-items:center;justify-content:center;gap:16px;padding:32px 0 16px;grid-column:1/-1}',
    '.artmie-load-more-btn{',
    '  display:inline-flex;align-items:center;gap:8px;',
    '  padding:14px 48px;',
    '  background:#1a1a1a;color:#fff;',
    '  border:none;border-radius:60px;',
    '  font-size:13px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;',
    '  cursor:pointer;transition:background .15s,transform .1s;',
    '  font-family:inherit;',
    '}',
    '.artmie-load-more-btn:hover{background:#333}',
    '.artmie-load-more-btn:active{transform:scale(.97)}',
    '.artmie-load-more-btn.loading{pointer-events:none;opacity:.7}',
    '.artmie-load-more-btn.loading .artmie-lm-text{display:none}',
    '.artmie-load-more-btn .artmie-lm-spinner{display:none}',
    '.artmie-load-more-btn.loading .artmie-lm-spinner{display:block;width:18px;height:18px;border:2px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:artmie-lm-spin .5s linear infinite}',
    '@keyframes artmie-lm-spin{to{transform:rotate(360deg)}}',
    '.artmie-load-more-count{font-size:14px;color:#555;font-weight:500;letter-spacing:0;white-space:nowrap}'
  ].join('\n');
  document.head.appendChild(style);

  /* ── Wait for DOM ready ── */
  function init() {
    var rl = document.querySelector('results-list');
    if (!rl) return;

    var infiniteAttr = rl.getAttribute('infinite-scroll');
    if (infiniteAttr !== 'true') return; /* Only activate when infinite scroll is on */

    var grid = rl.querySelector('[ref="grid"]');
    var sentinel = rl.querySelector('[ref="viewMoreNext"]');
    if (!grid || !sentinel) return;

    /* Disconnect the automatic IntersectionObserver.
       results-list.js is a module and runs AFTER this defer script,
       so we retry until the observer appears and disconnect it. */
    function killAutoScroll() {
      if (rl.infinityScrollObserver) {
        rl.infinityScrollObserver.disconnect();
        return true;
      }
      return false;
    }
    if (!killAutoScroll()) {
      var retries = 0;
      var killTimer = setInterval(function () {
        if (killAutoScroll() || retries++ > 30) clearInterval(killTimer);
      }, 100);
    }

    /* Create load more wrapper */
    var wrap = document.createElement('div');
    wrap.className = 'artmie-load-more-wrap';

    var btn = document.createElement('button');
    btn.className = 'artmie-load-more-btn';
    btn.type = 'button';
    btn.innerHTML = '<span class="artmie-lm-text">Načítať viac</span><span class="artmie-lm-spinner"></span>';

    var countEl = document.createElement('div');
    countEl.className = 'artmie-load-more-count';

    wrap.appendChild(btn);
    wrap.appendChild(countEl);

    /* Insert after the grid (before the sentinel) */
    sentinel.parentNode.insertBefore(wrap, sentinel);

    /* Update count display */
    function updateCount() {
      var items = grid.querySelectorAll('.product-grid__item');
      var lastPage = parseInt(grid.getAttribute('data-last-page'), 10) || 1;
      var currentItems = items.length;
      var itemsPerPage = parseInt(grid.getAttribute('data-per-page'), 10) || 16;
      var totalProducts = lastPage * itemsPerPage;

      /* Try to get real total from the collection count element */
      var countSource = document.querySelector('.collection-product-count, [data-product-count]');
      if (countSource) {
        var parsed = parseInt(countSource.textContent, 10);
        if (!isNaN(parsed) && parsed > 0) totalProducts = parsed;
      }

      /* Get current page from last card */
      var lastCard = items[items.length - 1];
      var currentPage = lastCard ? parseInt(lastCard.getAttribute('data-page'), 10) : 1;

      if (currentPage >= lastPage) {
        /* All pages loaded — hide button */
        wrap.style.display = 'none';
      } else {
        wrap.style.display = '';
        /* Locale-aware "X of Y products" label */
        var host = (window.location.hostname || '').toLowerCase();
        var fmt;
        if (/(^|\.)artmie\.hr$/.test(host)) {
          fmt = currentItems + ' od ' + totalProducts + ' proizvoda';
        } else if (/(^|\.)artmie\.si$/.test(host)) {
          fmt = currentItems + ' od ' + totalProducts + ' izdelkov';
        } else if (/(^|\.)artmie\.it$/.test(host)) {
          fmt = currentItems + ' di ' + totalProducts + ' prodotti';
        } else if (/(^|\.)artmie\.gr$/.test(host)) {
          fmt = currentItems + ' από ' + totalProducts + ' προϊόντα';
        } else if (/(^|\.)artmie\.(de|at)$/.test(host)) {
          fmt = currentItems + ' von ' + totalProducts + ' Produkten';
        } else if (host.indexOf('bg-bg') !== -1 || host.indexOf('artmie.bg') !== -1) {
          fmt = currentItems + ' от ' + totalProducts + ' продукта';
        } else {
          fmt = currentItems + ' z ' + totalProducts + ' produktov';
        }
        countEl.textContent = fmt;
      }
    }

    updateCount();

    /* Click handler */
    btn.addEventListener('click', function () {
      if (btn.classList.contains('loading')) return;
      btn.classList.add('loading');

      /* Get current last card's page */
      var items = grid.querySelectorAll('.product-grid__item');
      var lastCard = items[items.length - 1];
      var currentPage = lastCard ? parseInt(lastCard.getAttribute('data-page'), 10) : 1;
      var nextPage = currentPage + 1;
      var lastPage = parseInt(grid.getAttribute('data-last-page'), 10) || 1;

      if (nextPage > lastPage) {
        btn.classList.remove('loading');
        wrap.style.display = 'none';
        return;
      }

      /* Use section rendering API to fetch next page */
      var sectionId = rl.getAttribute('section-id');
      var url = new URL(window.location.href);
      url.searchParams.set('page', nextPage.toString());

      /* Build section rendering URL */
      var renderUrl = new URL(url);
      renderUrl.searchParams.set('section_id', sectionId);

      fetch(renderUrl.toString())
        .then(function (resp) { return resp.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[ref="grid"]');
          if (!newGrid) throw new Error('No grid in response');

          var newItems = newGrid.querySelectorAll(':scope > [ref="cards[]"]');
          if (newItems.length === 0) throw new Error('No items in response');

          /* Append new items */
          newItems.forEach(function (item) {
            grid.appendChild(item);
          });

          /* Update URL */
          history.pushState('', '', url.toString());

          /* Update button state */
          btn.classList.remove('loading');
          updateCount();

          /* Pre-fetch next page for faster loading */
          var futureNextPage = nextPage + 1;
          if (futureNextPage <= lastPage) {
            var prefetchUrl = new URL(window.location.href);
            prefetchUrl.searchParams.set('page', futureNextPage.toString());
            prefetchUrl.searchParams.set('section_id', sectionId);
            fetch(prefetchUrl.toString()).catch(function () {});
          }
        })
        .catch(function (err) {
          console.error('Load more failed:', err);
          btn.classList.remove('loading');
        });
    });

    /* Watch for filter changes that reset the grid */
    var observer = new MutationObserver(function () {
      setTimeout(updateCount, 500);
    });
    observer.observe(grid, { childList: true, attributes: true, attributeFilter: ['data-last-page'] });
  }

  /* Run when DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }
})();

